import { ArrowRight, Mail, Globe, Phone } from 'lucide-react';

const WA_GENERIC = 'https://api.whatsapp.com/send/?phone=5562994767293&text&type=phone_number&app_absent=0';

export default function Footer() {
  return (
    <footer
      id="contato"
      data-testid="footer-section"
      className="bg-[#0A2540] text-white"
    >
      {/* CTA Band */}
      <div className="border-b border-white/10">
        <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-24 py-16 md:py-24 text-center">
          <h2
            className="text-2xl sm:text-3xl lg:text-4xl font-bold tracking-tight leading-tight mb-4"
            style={{ fontFamily: "'Inter', sans-serif", letterSpacing: '-1px' }}
          >
            Pronto para economizar com a sua contabilidade?
          </h2>
          <p className="text-white/60 text-base sm:text-lg max-w-xl mx-auto mb-8">
            Agende um diagnóstico gratuito e descubra como podemos ajudar sua empresa a crescer.
          </p>
          <a
            href={WA_GENERIC}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="footer-cta-whatsapp"
            className="inline-flex items-center gap-2 bg-[#10B981] text-white px-8 py-4 rounded-lg font-semibold text-base hover:bg-[#059669] transition-colors"
          >
            Fale com um contador
            <ArrowRight size={18} />
          </a>
        </div>
      </div>

      {/* Footer Info */}
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-24 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10">
          {/* Brand */}
          <div>
            <span
              className="text-2xl font-bold block mb-4"
              style={{ fontFamily: "'Inter', sans-serif", letterSpacing: '-2px' }}
            >
              <span className="text-white">Fin</span>
              <span className="text-[#10B981]">Contex</span>
            </span>
            <p className="text-white/50 text-sm leading-relaxed max-w-xs">
              Contabilidade & Consultoria especializada em MEIs e PMEs. Sua empresa em boas mãos.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-sm uppercase tracking-[0.2em] font-semibold text-white/70 mb-4">
              Navegação
            </h4>
            <div className="flex flex-col gap-2">
              {[
                { label: 'Serviços', href: '#servicos' },
                { label: 'Como Funciona', href: '#como-funciona' },
                { label: 'Diferenciais', href: '#diferenciais' },
                { label: 'Planos', href: '#planos' },
                { label: 'FAQ', href: '#faq' },
              ].map((link) => (
                <a
                  key={link.href}
                  href={link.href}
                  data-testid={`footer-link-${link.href.slice(1)}`}
                  className="text-white/50 hover:text-[#10B981] transition-colors text-sm"
                  onClick={(e) => {
                    e.preventDefault();
                    document.querySelector(link.href)?.scrollIntoView({ behavior: 'smooth' });
                  }}
                >
                  {link.label}
                </a>
              ))}
            </div>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-sm uppercase tracking-[0.2em] font-semibold text-white/70 mb-4">
              Contato
            </h4>
            <div className="flex flex-col gap-3">
              <a
                href={WA_GENERIC}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="footer-whatsapp-link"
                className="flex items-center gap-2 text-white/50 hover:text-[#10B981] transition-colors text-sm"
              >
                <Phone size={14} />
                WhatsApp
              </a>
              <a
                href="mailto:contato@fincontex.com.br"
                data-testid="footer-email-link"
                className="flex items-center gap-2 text-white/50 hover:text-[#10B981] transition-colors text-sm"
              >
                <Mail size={14} />
                contato@fincontex.com.br
              </a>
              <a
                href="https://www.fincontex.com.br"
                target="_blank"
                rel="noopener noreferrer"
                data-testid="footer-website-link"
                className="flex items-center gap-2 text-white/50 hover:text-[#10B981] transition-colors text-sm"
              >
                <Globe size={14} />
                www.fincontex.com.br
              </a>
            </div>
          </div>

          {/* Legal */}
          <div>
            <h4 className="text-sm uppercase tracking-[0.2em] font-semibold text-white/70 mb-4">
              Informações Legais
            </h4>
            <div className="flex flex-col gap-2 text-white/40 text-sm">
              <p>CNPJ: 54.226.770/0001-86</p>
              <p>Contadora responsável:</p>
              <p>CRC GO 24.443/O-3</p>
            </div>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="border-t border-white/10 mt-10 pt-6 text-center">
          <p className="text-white/30 text-xs">
            © {new Date().getFullYear()} FinContex · Todos os direitos reservados
          </p>
        </div>
      </div>
    </footer>
  );
}
